import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
const DEFAULT_LAYOUT = () => import('@/layout/default-layout.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    //404路由 将匹配所有内容并将其放在 `$route.params.pathMatch` 下
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/not-found/index.vue"),
  },
  {
    path: "/",
    redirect: 'login'
  },
  {
    path: "/homeFirst",
    name: "homeFirst",
    component: DEFAULT_LAYOUT,
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
      },
    ],
  },
  {
    path: "/NewOrder",
    name: "NewOrder",
    component: DEFAULT_LAYOUT,
    children: [
      {
        path: 'NotSend',
        name: 'NotSend',
        component: () => import('@/views/neworder/NotSend.vue'),
      },

      {
        path: 'ToBeSigned',
        name: 'ToBeSigned',
        component: () => import('@/views/neworder/ToBeSigned.vue'),
      },
    ],
  },
  {
    path: "/sendGrade",
    name: "sendGrade",
    component: DEFAULT_LAYOUT,
    children: [
      {
        path: "checkStorage",
        name: "checkStorage",
        component: () => import("@/views/sendGrade/checkStorage.vue")
      },
      {
        path: "checkStorage-ccg",
        name: "checkStorage-ccg",
        component: () => import("@/views/sendGrade/checkStorage-ccg.vue")
      },
      {
        path: "enterInfor",
        name: "enterInfor",
        component: () => import("@/views/sendGrade/enterInfor.vue")
      },
      {
        path: "enterScore",
        name: "enterScore",
        component: () => import("@/views/sendGrade/enterScore.vue")
      },
      {
        path: "enterScore-ccg",
        name: "enterScore-ccg",
        component: () => import("@/views/sendGrade/enterScore-ccg.vue")
      },
    ]
  },
  {
    path: "/sendBack",
    name: "sendBack",
    component: DEFAULT_LAYOUT,
    children: [
      {
        path: "applyForReturn",
        name: "applyForReturn",
        component: () => import("@/views/sendBack/applyForReturn.vue")
      },
      {
        path: "returnToStorage",
        name: "returnToStorage",
        component: () => import("@/views/sendBack/returnToStorage.vue")
      },
    ]
  },
  {
    path: "/completeOrderPage",
    name: "completeOrderPage",
    component: DEFAULT_LAYOUT,
    children: [
      {
        path: '/completeOrder',
        name: 'completeOrder',
        component: () => import('@/views/completeOrder/index.vue'),
      },
    ],
  },
  {
    path: "/allOrdersPage",
    name: "allOrdersPage",
    component: DEFAULT_LAYOUT,
    children: [
      {
        path: '/allOrders',
        name: 'allOrders',
        component: () => import('@/views/allOrders/index.vue'),
      },
      {
        path: '/abnormalOrders',
        name: 'abnormalOrders',
        component: () => import('@/views/abnormalOrders/index.vue'),
      },
    ],
  },
  {
    path: "/dataReportPage",
    name: "dataReportPage",
    component: DEFAULT_LAYOUT,
    children: [
      {
        path: '/dataReport',
        name: 'dataReport',
        component: () => import('@/views/dataReport/index.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
